var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250.045,
    height: 255.627,
    viewBox: "0 0 250.045 255.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(17401.045 -5124)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4849",
    "data-name": "Group 4849",
    transform: "translate(-17369.615 5124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21173",
    "data-name": "Path 21173",
    d: "M615.455,240.249H543.661a6.771,6.771,0,0,1-4.441-1.677L509.648,212.49a5.55,5.55,0,0,0-3.678-1.39H480.45V123.078a6.335,6.335,0,0,1,6.328-6.328H609.126a6.335,6.335,0,0,1,6.328,6.328Z",
    transform: "translate(-466.451 -116.75)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 13.424,
    cy: 13.424,
    r: 13.424,
    transform: "translate(29.916 13.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21174",
    "data-name": "Path 21174",
    d: "M650.106,169.5h-24.93a1.726,1.726,0,0,0,0,3.452h24.93a1.726,1.726,0,0,0,0-3.452Z",
    transform: "translate(-554.605 -149.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21175",
    "data-name": "Path 21175",
    d: "M686.3,198h-61.45a1.765,1.765,0,0,0,0,3.452H686.3a1.765,1.765,0,0,0,0-3.452Z",
    transform: "translate(-554.605 -166.838)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21176",
    "data-name": "Path 21176",
    d: "M626.756,258.25H536.035a1.783,1.783,0,0,0,0,3.452h90.722a1.783,1.783,0,0,0,0-3.452Z",
    transform: "translate(-499.894 -203.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21177",
    "data-name": "Path 21177",
    d: "M626.756,286.25H536.035a1.783,1.783,0,0,0,0,3.452h90.722a1.783,1.783,0,0,0,0-3.452Z",
    transform: "translate(-499.894 -221.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21178",
    "data-name": "Path 21178",
    d: "M626.756,314.25H536.035a1.783,1.783,0,0,0,0,3.452h90.722a1.783,1.783,0,0,0,0-3.452Z",
    transform: "translate(-499.894 -238.502)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21179",
    "data-name": "Path 21179",
    d: "M626.756,342.25H536.035a1.783,1.783,0,0,0,0,3.452h90.722a1.783,1.783,0,0,0,0-3.452Z",
    transform: "translate(-499.894 -255.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21180",
    "data-name": "Path 21180",
    d: "M770.455,282.785H639.212a6.665,6.665,0,0,1-3.676-1.1l-.086-.057V192.078a6.336,6.336,0,0,1,6.328-6.328H764.126a6.335,6.335,0,0,1,6.328,6.328Z",
    transform: "translate(-562.003 -159.286)",
    fill: "#042"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 13.424,
    cy: 13.424,
    r: 13.424,
    transform: "translate(89.364 40.463)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21181",
    "data-name": "Path 21181",
    d: "M805.106,238.5h-24.93a1.726,1.726,0,1,0,0,3.452h24.93a1.726,1.726,0,1,0,0-3.452Z",
    transform: "translate(-650.157 -191.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21182",
    "data-name": "Path 21182",
    d: "M841.3,267h-61.45a1.765,1.765,0,0,0,0,3.452H841.3a1.765,1.765,0,0,0,0-3.452Z",
    transform: "translate(-650.157 -209.374)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21183",
    "data-name": "Path 21183",
    d: "M781.756,327.25H691.035a1.783,1.783,0,0,0,0,3.452h90.722a1.783,1.783,0,0,0,0-3.452Z",
    transform: "translate(-595.446 -246.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21184",
    "data-name": "Path 21184",
    d: "M781.756,355.25H691.035a1.783,1.783,0,0,0,0,3.452h90.722a1.783,1.783,0,0,0,0-3.452Z",
    transform: "translate(-595.446 -263.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21185",
    "data-name": "Path 21185",
    d: "M781.756,383.25H691.035a1.783,1.783,0,0,0,0,3.452h90.722a1.783,1.783,0,0,0,0-3.452Z",
    transform: "translate(-595.446 -281.038)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21186",
    "data-name": "Path 21186",
    d: "M781.756,411.25H691.035a1.783,1.783,0,0,0,0,3.452h90.722a1.783,1.783,0,0,0,0-3.452Z",
    transform: "translate(-595.446 -298.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21187",
    "data-name": "Path 21187",
    d: "M656.045,389.4H521.16a5.731,5.731,0,0,1-3.571-1.243c-.081-.061-.157-.127-.234-.2l-11.418-10.068L487.781,361.88a6.51,6.51,0,0,0-4.311-1.63h-33a6.529,6.529,0,0,0-6.52,6.52v149.2a6.529,6.529,0,0,0,6.52,6.52H656.045a6.529,6.529,0,0,0,6.52-6.52V395.919A6.529,6.529,0,0,0,656.045,389.4ZM661.8,515.966a5.76,5.76,0,0,1-5.753,5.753H450.47a5.76,5.76,0,0,1-5.753-5.753V366.77a5.76,5.76,0,0,1,5.753-5.753h33a5.739,5.739,0,0,1,3.8,1.438l17.5,15.437,12.066,10.643a6.577,6.577,0,0,0,4.315,1.63H656.045a5.76,5.76,0,0,1,5.753,5.753Z",
    transform: "translate(-443.95 -266.859)",
    fill: "#10384f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21192",
    "data-name": "Path 21192",
    d: "M693.463,595.889H580.7a5.76,5.76,0,0,1-5.753-5.753V528a5.76,5.76,0,0,1,5.753-5.753H693.463A5.76,5.76,0,0,1,699.216,528v62.133A5.76,5.76,0,0,1,693.463,595.889ZM580.7,523.017A4.992,4.992,0,0,0,575.717,528v62.133a4.992,4.992,0,0,0,4.986,4.986H693.463a4.992,4.992,0,0,0,4.986-4.986V528a4.992,4.992,0,0,0-4.986-4.986Z",
    transform: "translate(-524.707 -366.726)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_122",
    "data-name": "Ellipse 122",
    cx: 13.424,
    cy: 13.424,
    r: 13.424,
    transform: "translate(60.79 165.112)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21193",
    "data-name": "Path 21193",
    d: "M730.606,563.5h-24.93a1.726,1.726,0,1,0,0,3.452h24.93a1.726,1.726,0,1,0,0-3.452Z",
    transform: "translate(-604.231 -392.155)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21194",
    "data-name": "Path 21194",
    d: "M766.8,592h-61.45a1.765,1.765,0,0,0,0,3.452H766.8a1.765,1.765,0,0,0,0-3.452Z",
    transform: "translate(-604.231 -409.725)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21195",
    "data-name": "Path 21195",
    d: "M707.256,652.25H616.535a1.783,1.783,0,0,0,0,3.452h90.722a1.783,1.783,0,0,0,0-3.452Z",
    transform: "translate(-549.52 -446.867)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21196",
    "data-name": "Path 21196",
    d: "M707.256,680.25H616.535a1.783,1.783,0,0,0,0,3.452h90.722a1.783,1.783,0,0,0,0-3.452Z",
    transform: "translate(-549.52 -464.128)",
    fill: "#e6e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4850",
    "data-name": "Group 4850",
    transform: "translate(-17401.045 5231.982)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_21166",
    "data-name": "Path 21166",
    d: "M527.9,192.627a51.785,51.785,0,1,0,2.936,76.478l63.52,53.6a4.772,4.772,0,1,0,6.162-7.288l-.007-.006-63.521-53.6a51.788,51.788,0,0,0-9.091-69.184Zm-4.095,64.023a38.8,38.8,0,1,1-4.632-54.672h0A38.8,38.8,0,0,1,523.805,256.65Z",
    transform: "translate(-442.719 -180.419)",
    fill: "#042"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21167",
    "data-name": "Path 21167",
    d: "M482.848,307.421a38.8,38.8,0,0,1-6.584-52.157q-1.113,1.121-2.151,2.347a38.8,38.8,0,1,0,59.3,50.04q1.036-1.228,1.952-2.516A38.8,38.8,0,0,1,482.848,307.421Z",
    transform: "translate(-456.434 -226.559)",
    fill: "#2b6636",
    opacity: 0.3,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.c5ec807abf4a392e32c2bca90ed16ab4.svg";
export { ForwardRef as ReactComponent };